var _path, _path2, _rect, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 139,
    viewBox: "0 0 140 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.31 16.639v118.44M119.07 16.638v115.92M26.46 105.468h91.979",
    stroke: "#979797",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.12 135.708h15.75M110.879 135.709h15.75",
    stroke: "#979797",
    strokeWidth: 5.04,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.52,
    y: 30.5,
    width: 134.82,
    height: 49.14,
    rx: 1.26,
    fill: "#fff",
    stroke: "#747D84",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 32.388 34.893 77.76",
    stroke: "#747D84",
    strokeWidth: 5.04,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m46.15 32.366 18.614 45.396M76.39 32.367l18.613 45.395M105.37 32.367l18.613 45.395",
    stroke: "#747D84",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.76 10.97a9.45 9.45 0 1 1-18.9 0 9.45 9.45 0 1 1 18.9 0zM128.519 10.97a9.45 9.45 0 1 1-18.9 0 9.45 9.45 0 0 1 18.9 0z",
    fill: "#E74C3C",
    stroke: "#FFB9B1",
    strokeWidth: 2.52
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m23.31 10.005 3.378-3.378.965.965-3.378 3.378 3.378 3.379-.965.965-3.378-3.379-3.379 3.379-.965-.965 3.378-3.379-3.378-3.378.965-.965 3.378 3.378zM119.069 10.007l3.378-3.379.965.965-3.378 3.379 3.378 3.378-.965.965-3.378-3.378-3.379 3.378-.965-.965 3.378-3.378-3.378-3.379.965-.965 3.379 3.379z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.99e0fc6477502d4e26fb0056da386bbf.svg";
export { ForwardRef as ReactComponent };